import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TransmissionModalService {

  private selectedTransmissionSubject = new BehaviorSubject<any>(null);
  public selectedTransmission$ = this.selectedTransmissionSubject.asObservable();

  constructor() { }

  setSelectedTransmission(transmission: any): void {
    this.selectedTransmissionSubject.next(transmission);
  }

  getSelectedTransmission(): any | null {
    return this.selectedTransmissionSubject.value;
  }

  clearSelectedTransmission(): void {
    this.selectedTransmissionSubject.next(null);
  }
}
